import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { radii } from 'style/config';
import { Text } from 'components/ui';

const DEFAULT_BASE_CSS = {
    borderRadius: radii[2],
    verticalAlign: 'middle',
    textTransform: 'uppercase'
};

function Flag({
    isLarge,
    display = 'inline-block',
    fontWeight = 'var(--font-weight-bold)',
    backgroundColor = 'black',
    color = 'white',
    paddingX = '.8em',
    baseCss = DEFAULT_BASE_CSS,
    ...props
}) {
    return (
        <Text
            width='max-content'
            fontSize={isLarge ? 'xs' : 10}
            lineHeight={isLarge ? 'base' : '1.3'}
            display={display}
            fontWeight={fontWeight}
            backgroundColor={backgroundColor}
            color={color}
            paddingX={paddingX}
            baseCss={baseCss}
            {...props}
        />
    );
}

Flag.shouldUpdatePropsOn = ['children'];

export default wrapFunctionalComponent(Flag, 'Flag');
